interface LanguageCaption {
  [lang: string]: string;
}

interface LanguageDictionary {
  [caption: string]: LanguageCaption;
}

const captions: LanguageDictionary = {
  AUTH_GUEST: {
    en: 'NHB Digital Ticketing',
  },
  AUTH_HEADER: {
    en: 'Your Heritage Account',
  },
  AUTH_HEADER_TOURIST: {
    en: 'Tourists and Foreign Residents',
  },
  AUTH_HELLO: {
    en: 'Hello!',
  },
  AUTH_BROWSE: {
    en: 'Browse',
  },
  AUTH_SIGN_UP_LOGIN: {
    en: 'Sign Up/Log In',
  },
  AUTH_MY_PROFILE: {
    en: 'My Profile',
  },
  AUTH_PAGE_TITLE: {
    en: 'My Account',
  },
  AUTH_PAGE_TITLE_CHECKOUT: {
    en: 'Checkout',
  },
  AUTH_BUTTON_SIGN_UP: {
    en: 'Sign Up',
  },
  AUTH_BUTTON_GET_OTP: {
    en: 'Get OTP',
  },
  AUTH_BUTTON_SINGPASS: {
    en: 'Continue with'
  },
  AUTH_BUTTON_TOURIST: {
    en: 'Continue with Email'
  },
  AUTH_BUTTON_SINGPASS_TOURIST: {
    en: 'Continue here'
  },
  AUTH_BUTTON_REDIRECT_TOURIST: {
    en: 'Click here'
  },
  AUTH_TAB_TITLE_SIGN_UP: {
    en: 'Sign Up',
  },
  AUTH_TAB_TITLE_LOGIN: {
    en: 'Log In',
  },
  AUTH_PAGE_SIGN_UP_TOS_1: {
    en:
      'By proceeding, you agree to create an account with the National Heritage Board.',
  },
  AUTH_PAGE_SIGN_UP_TOS_2: {
    en: 'View T&Cs.',
  },
  AUTH_PAGE_SIGN_UP_FORM_LABEL_PHONE_NUMBER: {
    en: 'Phone Number',
  },
  AUTH_PAGE_SIGN_UP_FORM_BUTTON_SUBMIT: {
    en: 'Sign Up',
  },
  AUTH_PAGE_LOGIN_FORM_LABEL_PHONE_NUMBER: {
    en: 'Enter your mobile no.',
  },
  AUTH_PAGE_LOGIN_FORM_LABEL_EMAIL: {
    en: 'Ex. user@gmail.com',
  },
  AUTH_PAGE_LOGIN_FORM_BUTTON_SUBMIT: {
    en: 'Log In',
  },
  AUTH_PAGE_LOGIN_FORM_BUTTON_FORGOT_PASSWORD: {
    en: "Can't access your account?",
  },
  AUTH_CITIZEN_SINGPASS_CAPTION: {
    en: 'Singaporeans and PRs'
  },
  AUTH_TOURIST_CAPTION: {
    en: 'Sign in with Email'
  },
  AUTH_TOURIST_SINGPASS_CAPTION: {
    en: "Don't have Singpass?"
  },
  AUTH_CANCEL_HEADER: {
    en: 'Authentication Failed'
  },
  AUTH_CANCEL_CAPTION: {
    en: 'An error occured during'
  },
  AUTH_CANCEL_SUB: {
    en: 'authentication. Please try again.'
  },
  BACK: {
    en: 'Back'
  },
  BACK_TO_HOME: {
    en: 'Back to Home'
  },
  OTP_PAGE_TITLE: {
    en: 'OTP Verification',
  },
  OTP_PAGE_SUBTITLE: {
    en: 'A One-Time-Pin has been sent to',
  },
  OTP_PAGE_FORM_OTP_PLACEHOLDER: {
    en: 'OTP Pin',
  },
  OTP_PAGE_FORM_VERIFY_OTP: {
    en: 'Verify OTP',
  },
  OTP_PAGE_CAPTION_EXPIRE: {
    en: 'Code expires in ',
  },
  OTP_PAGE_CAPTION_CHANGE_NUMBER: {
    en: 'Change number',
  },
  OTP_PAGE_CAPTION_CHANGE_EMAIL: {
    en: 'Change email',
  },
  OTP_PAGE_CAPTION_RESENT_OTP: {
    en: 'Resend OTP',
  },
  ACCOUNT_SETUP_NAV_TITLE: {
    en: 'My Account',
  },
  ACCOUNT_SETUP_TITLE: {
    en: 'Create your Heritage Account',
  },
  ACCOUNT_SETUP_SUBTITLE: {
    en: 'To enjoy local rates, please verify your citizenship.',
  },
  ACCOUNT_SETUP_FORM_CITIZEN_ACK_CAPTION: {
    en: 'I’m a Singaporean citizen/Permanent Resident',
  },
  ACCOUNT_SETUP_FORM_NRIC_PLACEHOLDER: {
    en: 'NRIC Number',
  },
  ACCOUNT_SETUP_FORM_SUBMIT: {
    en: 'Confirm',
  },
  ACCOUNT_SETUP_SIGN_OUT: {
    en: 'Signout',
  },
  APP_BAR_HEADER: {
    en: 'Ticketing',
  },
  APP_BAR_SUBHEADER: {
    en: 'National Museum Singapore',
  },
  HOME_BROWSE: {
    en: 'Browse',
  },
  TICKET_ADD_TO_CART: {
    en: 'Add to Cart',
  },
  TICKET_ADDING_TO_CART: {
    en: 'Adding to cart...'
  },
  TICKET_SELECT: {
    en: 'Select'
  },
  TICKET_DESCRIPTION: {
    en: 'Description',
  },
  TICKET_QUANTITY: {
    en: 'Quantity',
  },
  TRANSACTION_CANCEL_HEADER: {
    en: 'Transaction Cancelled',
  },
  TRANSACTION_CANCEL_CAPTION: {
    en: 'Please proceed to the counter to'
  },
  TRANSACTION_CANCEL_SUB: {
    en: 'purchase your ticket instead.'
  },
  SELECT: {
    en: 'Select',
  },
  NEXT: {
    en: 'Next',
  },
  CART_HEADER: {
    en: 'Cart',
  },
  CART_DATE_OF_VISIT: {
    en: 'Date of visit',
  },
  ADMISSIONS: {
    en: 'Admissions'
  },
  CART_SUBTOTAL: {
    en: 'Subtotal',
  },
  CART_CONFIRM: {
    en: 'Confirm',
  },
  DATE_PICKER_HEADER: {
    en: 'Select date of visit',
  },
  SELECT_SLOT: {
    en: 'Select a time',
  },
  SUNDAY: {
    en: 'Sunday',
  },
  MONDAY: {
    en: 'Monday',
  },
  TUESDAY: {
    en: 'Tuesday',
  },
  WEDNESDAY: {
    en: 'Wednesday',
  },
  THURSDAY: {
    en: 'Thursday',
  },
  FRIDAY: {
    en: 'Friday',
  },
  SATURDAY: {
    en: 'Saturday',
  },
  JANUARY: {
    en: 'Jan',
  },
  FEBRUARY: {
    en: 'Feb',
  },
  MARCH: {
    en: 'Mar',
  },
  APRIL: {
    en: 'Apr',
  },
  MAY: {
    en: 'May',
  },
  JUNE: {
    en: 'Jun',
  },
  JULY: {
    en: 'Jul',
  },
  AUGUst: {
    en: 'Aug',
  },
  SEPTEMBER: {
    en: 'Sep',
  },
  OCTOBER: {
    en: 'Oct',
  },
  NOVEMBER: {
    en: 'Nov',
  },
  DECEMBER: {
    en: 'Dec',
  },
  CHECKOUT_HEADER: {
    en: 'Checkout',
  },
  CHECKOUT_HEADER_STEP_1: {
    en: 'Step 1: Verify'
  },
  CHECKOUT_HEADER_STEP_1_EMAIL: {
    en: 'Missing Email'
  },
  CHECKOUT_HEADER_STEP_2: {
    en: 'Step 2: Payment'
  },
  CHECKOUT_HEADER_STEP_3: {
    en: 'Step 3: Redeem'
  },
  CHECKOUT_HEADER_SUBTITLE_1_EMAIL: {
    en: 'Please input your email'
  },
  CHECKOUT_HEADER_SUBTITLE_1_VERIFY: {
    en: 'Please verify your information.'
  },
  CHECKOUT_HEADER_SUBTITLE_1_CONFIRM: {
    en: 'Please confirm your ticket details.'
  },
  CHECKOUT_HEADER_SUBTITLE_1_MOBILE: {
    en: 'Please enter your mobile number.'
  },
  CHECKOUT_HEADER_SUBTITLE_2: {
    en: 'Please proceed to checkout.'
  },
  CHECKOUT_HEADER_SUBTITLE_3: {
    en: 'Your payment is successful.'
  },
  CHECKOUT_LOCAL_VERIFICATION: {
    en: 'Local Verification',
  },
  CHECKOUT_FILL_IN_NRIC: {
    en: 'Please fill in NRIC numbers for the remaining',
  },
  CHECKOUT_FILL_IN_NRIC_TICKET: {
    en: 'ticket(s)',
  },
  CHECKOUT_NEXT: {
    en: 'Next',
  },
  CHECKOUT_VERIFICATION_SUCCESS: {
    en: 'Verification Success',
  },
  CHECKOUT_VERIFICATION_SUCCESS_SUB: {
    en: 'Please proceed to the third-party checkout page to &nbsp;<br /> complete your order and make payment if required',
  },
  CHECKOUT_VERIFICATION_SUCCESS_SUB_MOBILE: {
    en: 'Please proceed to the third-party checkout page to complete your order and make payment if required',
  },
  CHECKOUT_VERIFICATION_SUCCESS_PAY: {
    en: 'Next',
  },
  CHECKOUT_REDIRECT_PAY_HEADER: {
    en: 'Redirecting to payment...',
  },
  CHECKOUT_PROCESS_PAY_HEADER: {
    en: 'Processing payment...',
  },
  CHECKOUT_PAY_SUB: {
    en: "Didn't manage to pay? Click here to try again.",
  },
  CHECKOUT_SECURING_HEADER: {
    en: 'Securing your tickets...',
  },
  CHECKOUT_PROCESS_ORDER_SUB: {
    en: 'Please give us a moment to process your order.',
  },
  CHECKOUT_SINGPASS_HEADER: {
    en: 'Authentication in progress...'
  },
  MY_TICKETS_HEADER: {
    en: 'My Tickets',
  },
  MY_TICKETS_LEFT_TAB: {
    en: 'To Redeem',
  },
  MY_TICKETS_RIGHT_TAB: {
    en: 'Redeemed',
  },
  MY_TICKETS_EXPIRED: {
    en: 'Others',
  },
  CHECKOUT_SUCCESS_HEADER: {
    en: 'Payment Success',
  },
  CHECKOUT_SUCCESS_HEADER_FREE: {
    en: 'Tickets Secured',
  },
  CHECKOUT_SUCCESS_SUB: {
    en: 'Please show your tickets to the counter staff to enter the museum.',
  },
  CHECKOUT_SUCCESS_SUB_CP: {
    en: 'Thank you for your purchase, your ticket has been sent to your email.',
  },
  CHECKOUT_SUCCESS_BUTTON: {
    en: 'View My Tickets',
  },
  CHECKOUT_FAILURE_HEADER: {
    en: 'Payment Failed',
  },
  CHECKOUT_FAILURE_NOT_ELIGIBLE_HEADER: {
    en: 'Unable to Process',
  },
  CHECKOUT_FAILURE_SUB: {
    en: 'Sorry, We were unable to process your payment, please try again.',
  },
  CHECKOUT_FAILURE_BUTTON: {
    en: 'Return to Homepage',
  },
  CONTINUE_SHOPPING: {
    en: 'Continue Shopping'
  },
  CHECKOUT_CONTINUE_SHOPPING_NACCC: {
    en: 'Continue shopping',
  },
  CHECKOUT_RETURN_HOMEPAGE: {
    en: 'Return to Homepage'
  },
  MY_HERITAGE_NONE_ACTIVITIES: {
    en: 'Have not taken part in any activity',
  },
  MY_HERITAGE_HEADER: {
    en: 'My Past Activities'
  },
  MY_PROFILE_HEADER: {
    en: 'My Profile'
  },
  RATING: {
    en: 'How was your experience with NHB Ticketing?'
  },
  FEEDBACK_SUBMITTED: {
    en: 'Feedback submitted!'
  },
  FEEDBACK_SUBMITTED_DESC: {
    en: 'Thanks for helping us improve our services!'
  },
  FEEDBACK_TEXTAREA: {
    en: 'Let us know what we did well or how we can improve!'
  },
  GIFT_REDEEM_TITLE: {
    en: 'Gift Redemption'
  },
  GIFT_REDEEM_SUBS: {
    en: 'Redeem an exclusive gift at the  Singapore Night Festival 2022! \n Input your email address to proceed.'
  },
  GIFT_REDEEM_PLACEHOLDER: {
    en: 'Enter your email'
  },
  GIFT_REDEEM_CHECKBOX: {
    en: 'I’d like to keep in touch with NHB'
  },
  GIFT_REDEEM_PROFILE_SUBS: {
    en: 'Claim an exclusive Singapore Night Festival \n 2022 gift by scanning your Heritage ID.'
  },
  GIFT_REDEEM_PROFILE_CLAIM: {
    en: 'Claim a free gift for the Singapore \n Night Festival! '
  }

}

export const GetCaption = (caption: string, language = 'en'): string => {
  if (!caption) return ''
  const c: LanguageCaption = captions[caption]
  if (!c) return caption
  return c[language]
}
